import { createContext } from 'react'

const defaultPhoneData = {
  phoneNumber: '',
  phoneCopy: '',
}

const PhoneDataContext = createContext(defaultPhoneData)

const PhoneDataProvider = ({ children, phoneData = defaultPhoneData }) => {
  return <PhoneDataContext.Provider value={phoneData}>{children}</PhoneDataContext.Provider>
}

export { PhoneDataContext, PhoneDataProvider }
